import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { useModalDialogContext } from 'client/hooks'

import {
  AppButton,
  AppHeader,
  AppModalDialog,
  AppParagraph,
} from 'client/ui-building-blocks'

const SubmitQuestionModal = () => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  const { showSubmitQuestionModal, toggleSubmitQuestionModal } = useModalDialogContext()

  if (!showSubmitQuestionModal) return null

  const onCloseClick = () => {
    if (!queryClient.isFetching() && !queryClient.isMutating()) {
      toggleSubmitQuestionModal(false)
    }
  }

  return (
    <AppModalDialog
      size="tiny"
      open={showSubmitQuestionModal}
      onClose={onCloseClick}
      Header={
        <AppHeader
          text={t('app.modals.submitQuestion.header')}
          iconProps={{ name: 'WARNING_SIGN', variant: 'warning' }}
          dividing
        />
      }
      Content={<AppParagraph text={t('app.modals.submitQuestion.description')} />}
      Actions={
        <AppButton
          variant="success"
          size="small"
          text={t('common.buttons.ok')}
          position="center"
          onClick={onCloseClick}
        />
      }
    />
  )
}

export default SubmitQuestionModal
